<template lang='pug'>
  .fpui-input-toggle
    toggle-button(
      v-model='model',
      :color="colors",
      :labels='labelsToggle',
      :width='widthToggle',
      :sync='sync'
    )
</template>

<script>
export default {
  props: {
    value: { type: Boolean, required: true, default: false },
    width: { type: Number },
    colors: {
      type: Object,
      default () {
        return {checked: '#00B6E6', unchecked: '#E2315E'}
      }
    },
    labels: {},
    sync: Boolean
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    widthToggle () {
      if (this.width) return this.width
      if (this.labels) {
        let longerText = ''
        let long = 0
        Object.keys(this.labels).forEach(key => {
          let length = (this.labels[key] && this.labels[key].length) || 0
          if (length > long) {
            long = length
            longerText = this.labels[key]
          }
        })
        if (long > 0) {
          return this.getTextWidth(longerText, 10) + 36
        }
      }
      return 80
    },
    labelsToggle () {
      if (typeof this.labels === 'undefined') return { checked: 'Checked', unchecked: 'Unchecked' }
      return this.labels
    }
  },
  methods: {
    getTextWidth (text, fontSize, pStyle) {
      var lDiv = document.createElement('div')
      document.body.appendChild(lDiv)
      if (pStyle != null) {
        lDiv.style = pStyle
      }
      lDiv.style.fontSize = `${fontSize}px`
      lDiv.style.position = 'absolute'
      lDiv.style.left = -1000
      lDiv.style.top = -1000
      lDiv.innerHTML = text
      var lResult = {
        width: lDiv.clientWidth,
        height: lDiv.clientHeight
      }
      document.body.removeChild(lDiv)
      lDiv = null
      return lResult.width
    }
  }
}
</script>

<style lang='less'>
</style>
